import { render } from "./EnergyValueBox.vue?vue&type=template&id=395505ea&scoped=true&ts=true"
import script from "./EnergyValueBox.vue?vue&type=script&lang=ts"
export * from "./EnergyValueBox.vue?vue&type=script&lang=ts"

import "./EnergyValueBox.vue?vue&type=style&index=0&id=395505ea&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-395505ea"]])

export default __exports__